import Vue from 'vue'
import Vuex from 'vuex'
import router from "@/router";
import i18n from "@/i18n";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    user_role: localStorage.getItem('user_role') || '',
    user_id: localStorage.getItem('user_id') || '',
    group_id: Number(localStorage.getItem('group_id')) || '',
    lang: localStorage.getItem('lang') || 'en',
    is_updated: Number(localStorage.getItem('is_updated')) || 0

  },
  getters: {
    isLoggedIn: state => !!state.token,
    userRole:state => state.user_role,
    user_id:state => state.user_id,
    group_id:state => state.group_id,
    is_updated:state => state.is_updated,
    getLang: state => state.lang

  },
  mutations: {
    auth_success(state, {token,user_role,user_id,group_id}) {
      state.token = token
      state.user_role = user_role
      state.user_id = user_id
      state.group_id = group_id
      localStorage.setItem('token', token)
      localStorage.setItem('user_role', user_role)
      localStorage.setItem('user_id', user_id)
      localStorage.setItem('group_id', group_id)
    },
    async logout(state) {
      state.token = ''
      state.user_role=''
      state.user_id=''
      state.group_id=''
      localStorage.removeItem('token')
      localStorage.removeItem('user_role')
      localStorage.removeItem('user_id')
      localStorage.removeItem('group_id')
      await router.push({path: '/login'})
    },
    setLang(state, lang) {
      state.lang = lang
      localStorage.setItem('lang', lang)
      i18n.locale=lang
    },
    setUpdateUser(state, {is_updated,group_id}) {
      state.is_updated = is_updated
      state.group_id = group_id
      localStorage.setItem('is_updated', is_updated)
      localStorage.setItem('group_id', group_id)
    }
  },
  actions: {
    login({commit}, {token,user_role,user_id,group_id}) {
      commit('auth_success', {token,user_role,user_id,group_id})
    },
    logout({commit}) {
      commit('logout')
    },
    setLang({commit}, lang) {
      commit('setLang', lang)
    },
    setUpdateUser({commit}, {is_updated,group_id}) {
      commit('setUpdateUser', {is_updated,group_id})
    }
  },
  modules: {}
})
